export { default } from './TimelineDot';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/TimelineDot/index.js
// module id = 385
// module chunks = 0